export const quickUpdateImport = () => import("@/pages/QuickUpdate");

export const prefetchQuickUpdate = () => {
  quickUpdateImport().catch(() => {});
};

export const prefetchShelterPage = () => {
  import("@/pages/ShelterPage").catch(() => {});
};

export const prefetchPanel = () => {
  import("@/pages/panel/PanelLayout").catch(() => {});
  import("@/pages/panel/Dashboard").catch(() => {});
};
